export default __webpack_public_path__ + "static/media/location-bg-icon-light.21fa4586.svg";